import User from 'models/core/user/Model.User';
import Model from 'models/Model';
import ContractRefundDealerPaymentControl from 'models/sales/contractRefundDealerPaymentControl/Model.ContractRefundDealerPaymentControl';
import ContractRefundPayee from 'models/sales/contractRefundPayee/Model.ContractRefundPayee';
import ContractRefundPayment from '../contractRefundPayment/Model.ContractRefundPayment';
import deleteContractRefundPaymentItemsByContractRefundId from './delete/Api.ContractRefundPaymentItem.Delete';
import contractRefundPaymentItemFindApi from './find/Api.ContractRefundPaymentItem.Find';
import contractRefundPaymentItemListApi from './list/Api.ContractRefundPaymentItem.List';
import contractRefundPaymentItemSaveApi from './save/Api.ContractRefundPaymentItem.Save';

export default class ContractRefundPaymentItem
  extends Model<Model.IContractRefundPaymentItem>({ icon: 'fas-cloud' })
  implements Model.Instance<Model.IContractRefundPaymentItem>
{
  id: number;
  totalAmount: number;
  totalAmountBeforeTax: number = 0;
  gstHstAmount: number = 0;
  provincialSalesTaxAmount: number = 0;
  paymentMethodCode: string;
  currency: string = 'CAD';
  createdAtLocal: string;

  contractRefundDealerPaymentControlId: number;
  contractRefundDealerPaymentControl?: ContractRefundDealerPaymentControl;

  contractRefundPayeeId: number;
  contractRefundPayee?: ContractRefundPayee;

  contractRefundPaymentId?: number;
  contractRefundPayment?: ContractRefundPayment;

  createdById?: number;
  createdBy?: User;

  isCancelled: boolean;
  isExcluded: boolean = false;

  paymentRequestedAtUtc?: string;
  readonly jobId?: string;
  readonly appNumber?: string;
  readonly templateName?: string;

  constructor(
    data: Partial<Model.IContractRefundPaymentItem> | Utils.FormData<Model.IContractRefundPaymentItem>,
    language?: Locale.Languages
  ) {
    super(
      {
        contractRefundPayee: ContractRefundPayee,
        contractRefundPayment: ContractRefundPayment,
        contractRefundDealerPaymentControl: ContractRefundDealerPaymentControl,
        createdBy: User,
      },
      language
    );
    this.update(data);
  }
  get displayInfo(): Model.DisplayInfo {
    return {
      id: this.id,
      title: this.id?.toString(),
    };
  }

  static async find(params: { id: number }) {
    const { payload, ...rest } = await contractRefundPaymentItemFindApi(params);
    return {
      ...rest,
      payload: new ContractRefundPaymentItem(payload),
    };
  }

  static async list(body?: Api.Finance.ContractRefundPaymentItem.List.IRequest) {
    const { payload, ...rest } = await contractRefundPaymentItemListApi(body);
    return {
      ...rest,
      payload: payload && {
        data: payload.data?.map((it) => new ContractRefundPaymentItem(it)),
        count: payload.count,
      },
    };
  }

  static async save(body: Api.Finance.ContractRefundPaymentItem.Save.IRequest) {
    return await contractRefundPaymentItemSaveApi(body);
  }

  static async deleteByContractRefundId(params: { contractRefundId: number }) {
    return await deleteContractRefundPaymentItemsByContractRefundId(params);
  }
}
